import CardIconDark from '@Resources/assets/icons/dark/cards.svg';
import ListIconDark from '@Resources/assets/icons/dark/list.svg';
import CardIconLight from '@Resources/assets/icons/light/cards.svg';
import ListIconLight from '@Resources/assets/icons/light/list.svg';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import ListIcon from '@mui/icons-material/FormatListBulleted';
import {
    SvgIcon,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import IconButton from '@Components/IconButton/IconButton';
import IconBtnStyles from '@Components/IconButton/IconButton.scss';
import { ViewProjectType } from '@Data/projects/Interfaces';
import Styles from './ProjectSortingComponents.scss';

const SelectProjectView = (props) => {
    const { selectedViewType, onSelectViewType } = props;

    const handleSelection = (value: ViewProjectType) => {
        onSelectViewType(value);
    };

    return (
        <div
            id="project-select-view-container"
            className={Styles.pscProjectViewContainer}
        >
            <div className={IconBtnStyles.iconBtnGroup}>
                <IconButton
                    id="project-veiw-cards-btn"
                    icon={
                        <SvgIcon inheritViewBox>
                            {selectedViewType === ViewProjectType.CARD ? (
                                <CardIconLight />
                            ) : (
                                <CardIconDark />
                            )}
                        </SvgIcon>
                    }
                    onClick={() => handleSelection(ViewProjectType.CARD)}
                    isSelected={selectedViewType === ViewProjectType.CARD}
                    tooltip="view as cards"
                />
                <IconButton
                    id="project-veiw-list-btn"
                    icon={
                        <SvgIcon inheritViewBox>
                            {selectedViewType === ViewProjectType.LIST ? (
                                <ListIconLight />
                            ) : (
                                <ListIconDark />
                            )}
                        </SvgIcon>
                    }
                    onClick={() => handleSelection(ViewProjectType.LIST)}
                    isSelected={selectedViewType === ViewProjectType.LIST}
                    tooltip="view as a list"
                />
            </div>
        </div>
    );
};

SelectProjectView.propTypes = {
    selectedViewType: PropTypes.oneOf([
        ViewProjectType.CARD,
        ViewProjectType.LIST,
    ]),
    onSelectViewType: PropTypes.func,
};
export default SelectProjectView;
